// DON'T EDIT THIS FILE: edit the original Triggers.ts files and regenerate derived files

import hook0 from "../framework/live-form-core-types/type-renderers.ts";
import hook1 from "../framework/live-form-entition/type-renderers.ts";
import hook2 from "../framework/live-form-entity-live-field/type-renderers.ts";
import hook3 from "../framework/live-form-html-editor-type/type-renderers.ts";

export default [hook0, hook1, hook2, hook3];
